export const arrayDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const arrayWorkDays = ['Пн-Пт', 'Сб-Вс'];
export const arraySevenDays = ['Пн-Вс'];
